import overrideTagHero from './actions/Hero/overrideTagHero';
import overrideWelcomeHero from './actions/Hero/overrideWelcomeHero';
import removeToolbarItems from './actions/removeToolbarItems';
import removeAllDiscussionsNavItem
  from './actions/Discussion/removeAllDiscussionsNavItem';
import replaceDiscussionBadges
  from './actions/Discussion/replaceDiscussionBadges';
import removePostUserBadges from "./actions/Discussion/removePostUserBadges";
import removeTextOnHover from "./actions/removeTextOnHover";
import overrideDiscussionListItem
  from "./actions/Discussion/overrideDiscussionListItem";
import alterSortingOptions from "./actions/alterSortingOptions";
import alterHeader from "./actions/alterHeader";
import alterFlaggedPosts from "./actions/Discussion/alterFlaggedPosts";
import alterDiscussionControls
  from "./actions/Discussion/alterDiscussionControls";
import extendComposerBody from "./actions/Discussion/extendComposerBody";
import addTagSearch from "./actions/Discussion/addTagSearch";
import HideSearchForRegularUsers from './actions/hideSearchForRegularUsers';
import addGetCurrentTagMethod from './actions/addGetCurrentTagMethod';
app.initializers.add('netcompany-ui-extender', () => {

  // Discussion
  addTagSearch();
  addGetCurrentTagMethod();
  alterDiscussionControls();
  alterFlaggedPosts();
  extendComposerBody();
  overrideDiscussionListItem();
  removeAllDiscussionsNavItem();
  removePostUserBadges();
  replaceDiscussionBadges();

  // Hero
  overrideTagHero();
  overrideWelcomeHero();

  // Miscellaneous
  alterHeader();
  alterSortingOptions();
  removeTextOnHover();
  removeToolbarItems();

  // hide search bar for non admin users
  HideSearchForRegularUsers();

}, -100); // sets the priority of the initializer
